module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>StatusIndicator displays some text inside a pill.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;StatusIndicator status=&quot;critical&quot;&gt;\n    Error\n&lt;/StatusIndicator&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/StatusIndicator/README.md
// module id = 391
// module chunks = 0